import React from 'react';

export const CheckSuccess = ({ color }: { color?: string }): JSX.Element => {
    const className = 'icon icon--check-success'
  color = color || '#18A03C';

  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M68.5716 37.3879V40.0165C68.5681 46.1777 66.573 52.1727 62.8839 57.1074C59.1949 62.0421 54.0095 65.6521 48.1012 67.3991C42.1928 69.146 35.878 68.9362 30.0986 66.801C24.3192 64.6658 19.3849 60.7196 16.0315 55.551C12.678 50.3823 11.0853 44.2681 11.4906 38.1202C11.896 31.9724 14.2779 26.1203 18.2809 21.4367C22.284 16.7531 27.6938 13.489 33.7035 12.1312C39.7133 10.7734 46.0009 11.3946 51.6287 13.9022M68.5716 17.1594L40.0001 45.7594L31.4287 37.188"
        stroke={color}
        strokeWidth="2.88267"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckSuccess;
